import { render, staticRenderFns } from "./praga.vue?vue&type=template&id=abb1d38e&"
import script from "./praga.vue?vue&type=script&lang=js&"
export * from "./praga.vue?vue&type=script&lang=js&"
import style0 from "./praga.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports